import React from 'react'
import "./../assets/css/style.css";
import colis from "./../assets/img/colis.png";
import { SiCrowdsource } from "react-icons/si";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoIosAirplane } from "react-icons/io";
import { IoIosSend } from "react-icons/io";
import { BiTransfer } from "react-icons/bi";
import Footer from "./../components/Footer";

const Home = () => {
  return (
    <div >
      <div className="container-fluid full-height">
          <div className="row h-100">

              <div className="col-md-6 left-section">
                  <p className="title">Bienvenu sur la plateforme de N.J Achat.</p>
                  <a href="/colis"><button className="cta">Suivre votre colis <FaArrowRightLong /></button></a>
              </div>

              <div className="col-md-6 right-section">
                  <img src={colis} alt="Illustration" className="img-fluid"/>
              </div>
          </div>
      </div>

      <div className="services-container text-center p-5">
        <h2 className="title mb-4">NOS SERVICES</h2>
        <div className="row justify-content-center">
          {/* Service 1 */}
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              <h1 className="icon-service"><SiCrowdsource/></h1>
              <h5 className="fw-bold">SOURCING depuis Madagascar</h5>
            </div>
          </div>

          {/* Service 2 */}
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              <h1 className="icon-service"><BiTransfer/></h1>
              <h5 className="fw-bold">Transfert d'Argent <br/> RMB - ARIARY</h5>
            </div>
          </div>

          {/* Service 3 */}
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              <h1 className="icon-service"><IoIosSend/></h1>
              <h5 className="fw-bold text-service">Envoi des colis <br/> CHINE - MADA</h5>
            </div>
          </div>

          {/* Service 4 */}
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-4 h-100">
              <h1 className="icon-service"><IoIosAirplane/></h1>
              <h5 className="fw-bold text-service">Voyage organisée</h5>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  )
}

export default Home
